import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f65b88c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "station-page" }
const _hoisted_2 = { class: "ws_common_operation ws_pt35 ws_pb20 ws_pr20" }
const _hoisted_3 = { class: "ws_ml20 ws_mr20" }

import { onMounted, ref, watch, computed } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import StationForm from './components/station-form-drawer.vue'
import Prediction from './components/prediction-drawer.vue'
import PredictionSingle from './components/prediction-drawer-single.vue'

import {
  queryDictionaryPage,
  dictionaryInfoDelete,
  queryDictionaryTreeList,
} from '@/api'
import { CODE_ENUM, PAGE_SIZES } from '@/common'
import OperationButtonList from '@/components/operation-button-list'
import { ElMessage } from 'element-plus'
import { msgbox } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { VUE_APP_ENV } = process.env

const buttonList = [
  {
    type: 'edit',
    text: '编辑',
  },
  {
    type: 'delete',
    text: '删除',
  },
]

const tableData: any = ref([])
const formInline = ref({
  stationId: undefined,
})
const advancedRef = ref()

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const col: any = ref([
  {
    prop: 'stationName',
    label: '地面站名称',
  },
  {
    prop: 'address',
    label: '位置',
  },
  {
    prop: 'location',
    label: '经纬度',
  },
])

const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData()
  const { data, reset } = queryData || {}

  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true

  console.log(keepAliveData, 'keepAliveData')
  console.log(data, 'data')

  const res: any = await queryDictionaryPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  queryDictionaryList()
  fetchList()
})
const dictionaryList: any = ref([])
const queryDictionaryList = async () => {
  const res: any = await queryDictionaryTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    dictionaryList.value = res.data || []
  }
}

const stationConf = ref({
  visible: false,
  data: {},
})

const predictionConf = ref({
  visible: false,
})

const handlePrediction = () => {
  predictionConf.value = {
    visible: true,
  }
}

const predictionSingleConf = ref({
  visible: false,
})

const handlePredictionSingle = () => {
  predictionSingleConf.value = {
    visible: true,
  }
}

const handleForm = (data?: any) => {
  stationConf.value = {
    visible: true,
    data,
  }
}

const handleDelete = (data: any) => {
  msgbox({
    tip: '请确认是否删除地面站？',
    thenFn: () => toDelete(data),
  })
}

const toDelete = async ({ id }: any) => {
  const res: any = await dictionaryInfoDelete({
    id,
  })
  if (res.code === CODE_ENUM.SUCCESS) {
    ElMessage.success('删除成功')
    fetchList()
  }
}

const toSatelliteMonitoring = () => {
  const baseUrl =
    VUE_APP_ENV === 'production'
      ? 'https://somdc.wstaiot.com/satellite-screen'
      : 'http://192.168.180.201/operation-platform/satellite-screen'

  window.open(baseUrl)
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        class: "advance-container",
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        border: true,
        "label-width": 96
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "地面站名称",
            prop: "stationId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.stationId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.stationId) = $event)),
                class: "ws_select",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.stationId,
                      label: item.stationName,
                      value: item.stationId
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          plain: "",
          onClick: handlePrediction
        }, {
          default: _withCtx(() => [
            _createTextVNode("多星过境预测")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: handlePredictionSingle
        }, {
          default: _withCtx(() => [
            _createTextVNode("单星过境预测")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: toSatelliteMonitoring
        }, {
          default: _withCtx(() => [
            _createTextVNode("卫星监测中心")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleForm({}))),
          type: "primary",
          class: "ws_ml25"
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          class: "ws_common_table"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
                key: item.prop
              }, { ...item }, { "show-overflow-tooltip": "" }), null, 16))
            }), 128)),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(OperationButtonList), {
                  scope: scope.row,
                  buttonList: buttonList,
                  onOnDelete: handleDelete,
                  onOnEdit: handleForm
                }, null, 8, ["scope"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(StationForm, {
      visible: stationConf.value.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((stationConf.value.visible) = $event)),
      data: stationConf.value.data,
      onOnSuccess: fetchList
    }, null, 8, ["visible", "data"]),
    _createVNode(Prediction, {
      visible: predictionConf.value.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((predictionConf.value.visible) = $event))
    }, null, 8, ["visible"]),
    _createVNode(PredictionSingle, {
      visible: predictionSingleConf.value.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((predictionSingleConf.value.visible) = $event))
    }, null, 8, ["visible"])
  ], 64))
}
}

})